<script>

  import axios from 'axios'
  import gql from 'graphql-tag'
  import { mapGetters } from 'vuex'
  import eventbus from '@/services/eventbus'

  import bookDefault from '@/components/shared/presentation/book-default'
  import bookCover from '@/components/shared/presentation/book-cover'
  import titreDefault from '@/components/shared/presentation/titre-default'
  import searchInput from './search/search-input'
  import bookRating from './search/book-rating'
  import defaultLayout from '../components/shared/layouts/default-layout'
  import loading from './search/loading'

  const findBook = gql`
    query findBookBy($id: String) {
      livre(id: $id) {
        id
        titre
        sous_titre
        couverture: couverture_url
        auteurs {
          nom
        }
      }
    }
  `
  const findBookByEan = gql`
    query findBookByEan($ean13: String) {
      livres: search_livres_by(attrs: { ean13: $ean13 }) {
        id
        titre
        sous_titre
        couverture: couverture_url
        auteurs {
          nom
        }
      }
    }
  `
  const findUser = gql`
    query findUser($id: String) {
      user: contexte_usager(id: $id) {
        id
        contexte {
          description
          titre
        }
      }
    }
  `

  export default {
    name: 'ClientScene',
    props: {
      ean13: {
        type: String,
      },
    },
    data () {
      return {
        suggestions: null,
        livre: null,
        livreId: null,
        livreEan13: null,
        search: null,
        user: null,
        loadingSuggestion: false,
      }
    },
    components: {
      searchInput,
      titreDefault,
      bookDefault,
      bookRating,
      layout: defaultLayout,
      loading,
      bookCover,
    },
    methods: {
      async findSuggestion (ean13) {
        this.loadingSuggestion = true
        try {
          const { suggestions } = await axios.get(`/api/v2/ia/suggestions/${ean13}.json`).then(({data}) => data)
          this.suggestions = suggestions
        } catch (e) {
          throw e
        } finally {
          this.loadingSuggestion = false
        }
      },
      onLivreSelect ({ id = null, ean13 }) {
        this.livreId = id
        this.$router.push({ name: 'suggestion', params: { ean13 } })
      },
      searchSuggestion (ean13) {
        this.livreEan13 = ean13
        this.findSuggestion(ean13)
      },
      resetSuggestion () {
        this.livreEan13 = null
        this.livreId = null
        this.livre = null
        this.loadingSuggestion = false
        this.search = null
        this.suggestions = null
      },
      showBookDesc (id) {
        eventbus.$emit('book:show-desc', id)
      },
    },
    apollo: {
      livre: {
        query () {
          return this.livreEan13 ? findBookByEan : findBook
        },
        variables () {
          return { id: this.livreId, ean13: this.livreEan13 }
        },
        skip () {
          return !(this.livreId || this.livreEan13)
        },
        update (data) {
          return this.livreEan13 ? data.livres[0] : data.livre
        },
      },
      user: {
        query: findUser,
        variables () {
          return { id: this.userId }
        },
        skip () {
          return !this.userId
        },
      },
    },
    computed: {
      ...mapGetters([
        'contexteId',
        'userId',
      ]),
      suggestedTitreIds () {
        return this.suggestions ? this.suggestions.map(({ id }) => id) : Array(8)
      },
      isBookSelected () {
        return this.livreId || this.livreEan13
      },
    },
    watch: {
      ean13: {
        immediate: true,
        handler (ean13) {
          if (ean13) this.searchSuggestion(ean13)
          else this.resetSuggestion()
        },
      },
    },
  }
</script>

<template lang="pug">

layout
  div.accueil-scene
    div.wrapper.columns
      .column.is-10.is-offset-1
        template(v-if="!isBookSelected")
          //input
          transition(name="slide-down")
            h1.bigtitle(v-show="!search") Robert veut lire
          search-input(v-show="!isBookSelected", @input="onLivreSelect", @search="search = arguments[0]")
          hr
          .box(v-if="user")
            h3.title.is-3(v-html="user.contexte.titre")
            div.content(v-html="user.contexte.description")
        template(v-else)
          loading(v-if="loadingSuggestion")
          div.suggestionwrapper(v-else)
            .containerr.tr
              router-link(class="button is-float-right", tag="button", :to="{ name: 'intro' }") Faire une nouvelle recherche
              book-cover.bookselected.mb3.mt3(:id="livre.id", v-if="livre", skin="preview")
            div.suggestions
              transition-group.columns.is-multiline(tag="ul", name="bounce", stagger="200", appear)
                li.column.is-3-widescreen.is-4-tablet.is-6-mobile(v-for="(id, index) in suggestedTitreIds", :key="index")
                  .suggestionplaceholder
                    book-rating.bookrating(v-if="id", :id="id", :contexte-id="contexteId", @show-desc="showBookDesc")
                    //- span(v-else) Suggestion
</template>

<style lang="postcss" scoped>
  .accueil-scene {

  }
</style>

<style lang="postcss">
  .accueil-scene {
    font-family: 'Open Sans', sans-serif;
    & h1{
      margin-bottom:50px;
    }
    & h3{
      margin:10px 0px 20px 0px;
    }
    & ul{
      padding:10px;
    }

    & li{
      list-style-type:circle;
    }

    & .column{
      list-style-type: square;

    }
    & .suggestionplaceholder {
      background-color: white;
      color: black;
      height: 100%;
    }
    & .suggestionwrapper {
      background-color: white;
      padding: 20px;
    }
    & .bookrating {
      height: 350px;
      border: 1px solid rgba(0, 0, 0, 0.14);
    }
    & .wrapper {
      text-align: center;
      margin: 0 auto;
    }
    & .bigtitle {
      font-size: 80px;
    }
    & .title {
      color: black;
    }
    & .box {
      text-align: left;
    }
    & .bookselected {
      & .img {
        width: auto;
        height: auto;
        object-fit: none;
      }
    }
  }
  .hero-head{
    & button{
      //padding:5px 0px 0px 0px;
    }

    & .container{
      //display:inline-block;
      //border:1px solid green;
      //width:48%;
    }

    & .headerc{

    }

    & .nav{
      //width:45%;
      //border:1px solid green;
    }
  }

  .suggestionwrapper{
    font-family: 'Open Sans', sans-serif;
    & .flex-auto{
      padding:15px;
    }
  }

</style>



// WEBPACK FOOTER //
// accueil-scene.vue?2f6d7307